import { call, put, takeLatest } from 'redux-saga/effects';

import { CorporateHealthOrder } from '@models/CorporateHealthOrder';
import { CorporateHealthOrderApi } from '@apis/CorporateHealthOrderApi';
import { SagaPayload } from '@utils/typescript';

import {
  corporateHealthOrderFetch,
  CorporateHealthOrderFetchPayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handleCorporateHealthOrderFetch({ payload }: SagaPayload<CorporateHealthOrderFetchPayload>) {
  const state: StateUpdatePayload = { corporateHealthOrder: null };
  try {
    state.corporateHealthOrder = (yield call(CorporateHealthOrderApi.get, payload)) as CorporateHealthOrder;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(corporateHealthOrderFetch, handleCorporateHealthOrderFetch);
}
